import {
  SET_CLEAR_ALL_STATE,
  SET_ERROR_RSO,
  SET_GET_FILE_RSO,
  SET_LOADING_FILE_RSO,
  SET_DATA,
  SET_FILE,
  SET_EXCEL_PREVIEW_DATA,
  SET_EXCEL_PREVIEW_COLUMNS,
  SET_COLUMN_LABELS,
  SET_HIGHLIGHTED_COLUMNS,
  CLEAR_HIGHLIGHTED_COLUMNS,
  SET_HIGHLIGHTED_ROWS,
  CLEAR_HIGHLIGHTED_ROWS,
  SET_VALUE_FORM,
  SET_ROW_LABELS,
} from './actionsTypes';

export const setClearAllState = () => ({
  type: SET_CLEAR_ALL_STATE,
});

export const setloadingFileRso = (value) => ({
  type: SET_LOADING_FILE_RSO,
  payload: value,
});

export const setGetFileRso = (value) => ({
  type: SET_GET_FILE_RSO,
  payload: value,
});

export const setErrorRso = (value) => ({
  type: SET_ERROR_RSO,
  payload: value,
});

export const setData = (value) => ({
  type: SET_DATA,
  payload: value,
});

export const setFile = (value) => ({
  type: SET_FILE,
  payload: value,
});

export const setExcelPreviewData = (value) => ({
  type: SET_EXCEL_PREVIEW_DATA,
  payload: value,
});

export const setExcelPreviewColumns = (value) => ({
  type: SET_EXCEL_PREVIEW_COLUMNS,
  payload: value,
});

export const setColumnLabels = (value) => {
  const mapped = value.map((item, index) => ({
    id: index,
    value: item,
    content: item,
    search: item,
  }));

  return {
    type: SET_COLUMN_LABELS,
    payload: mapped,
  };
};

export const setHighlightedColumns = (name, columnSelect) => ({
  type: SET_HIGHLIGHTED_COLUMNS,
  payload: { name, columnSelect },
});

export const clearHighlightedColumns = () => ({
  type: CLEAR_HIGHLIGHTED_COLUMNS,
});

export const setHighlightedRows = (name, rows) => ({
  type: SET_HIGHLIGHTED_ROWS,
  payload: { name, rows },
});

export const clearHighlightedRows = () => ({
  type: CLEAR_HIGHLIGHTED_ROWS,
});

export const setValueForm = (value) => {
  return {
    type: SET_VALUE_FORM,
    payload: value,
  };
};

export const setRowLabels = (value) => {
  const rest = value.map((item) => ({
    id: item,
    value: item,
    content: item,
    search: item,
  }));

  return {
    type: SET_ROW_LABELS,
    payload: rest,
  };
};
